module.exports = __webpack_public_path__ + "media/images/weather/345_day-52b25bd53b2ed12315e15245cc1e5a67.png";